<template>
    <v-container fluid>
        <v-progress-linear
            v-if="loading"
            class="mb-8"
            color="primary"
            indeterminate
        ></v-progress-linear>
        <v-row v-if="!loading">
            <v-col cols="12">
                <v-card class="elevation-0">
                    <v-card-title class="d-none d-lg-block warning white--text">
                        Subempreitadas
                    </v-card-title>
                    <v-card-title class="d-block d-lg-none warning white--text text-caption text-center">
                        Subempreitadas
                    </v-card-title>
                    <v-card-text>
                        <v-simple-table class="d-none d-lg-block" fixed-header :key="reloader">
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th v-if="aggregator" width="5%">
                                        </th>
                                        <th class="text-left" :width="aggregator ? '60%' : '40%'">
                                            Trabalho
                                        </th>
                                        <th class="text-left" width="15%">
                                            Frente de Obra
                                        </th>
                                        <th class="text-left" width="15%">
                                            Classe
                                        </th>
                                        <th class="text-left" width="7%">
                                            QTD
                                        </th>
                                        <th class="text-left" width="5%">
                                            Nota
                                        </th>
                                        <th class="text-left" width="10%">
                                            Opções
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr
                                        v-for="item in computeSubempreitadas" :key="item.id"
                                    >
                                        <td v-if="aggregator">
                                            <v-icon v-if="lineTotalApproved(item)" color="success">mdi-check-decagram</v-icon>
                                            <span v-else>{{lineApprovalState(item)}}</span>
                                        </td>
                                        <td>
                                            <validation-provider v-slot="{ errors }" vid="subempreitada" name="subempreitada" rules="required">
                                                <v-autocomplete
                                                    class="mt-4"
                                                    outlined dense
                                                    :items="subempreitadas"
                                                    :item-text="item => item.Codigo + ' - ' + item.Descricao"
                                                    item-value="Id"
                                                    label="Subempreitada"
                                                    :error-messages="errors"
                                                    v-model="item.subempreitada"
                                                />
                                            </validation-provider>
                                        </td>
                                        <td>
                                            <div v-if="showFrente(item)">
                                                <validation-provider v-slot="{ errors }" vid="Frentes" name="Frentes" rules="required">
                                                    <v-autocomplete
                                                        :value="item.frente_id"
                                                        :items="frentes_obra"
                                                        outlined
                                                        dense
                                                        class="mt-4"
                                                        :disabled="item.id.includes('non-editable')"
                                                        :item-text="ob => getText(ob)"
                                                        item-value="ID"
                                                        :error-messages="errors"
                                                        label="Frentes de Obra *"          
                                                        @change="val => updateField(item, 'frente_id', val, 'i')"                                         
                                                    />
                                                </validation-provider>
                                            </div>
                                        </td>
                                        <td>
                                            <div v-if="showClasse(item)">
                                                <validation-provider v-slot="{ errors }" vid="Classes" name="Classes" rules="required">
                                                    <v-autocomplete
                                                        :value="item.classe_id"
                                                        :items="item.available_classes"
                                                        class="mt-4"
                                                        outlined
                                                        dense
                                                        :item-text="ob => ob.Descricao"
                                                        :disabled="item.id.includes('non-editable')"
                                                        item-value="ClasseId"
                                                        :error-messages="errors"
                                                        label="Classe *"
                                                        @change="val => updateField(item, 'classe_id', val, 'i')"     
                                                    />
                                                </validation-provider>
                                            </div>
                                        </td> 
                                        <td>
                                            <v-text-field 
                                                class="mt-4"
                                                label="QTD"
                                                outlined dense
                                                placeholder="Insira qtd."
                                                inputmode="decimal"
                                                :rules="[v => v === '' || /^[0-9]*\.?[0-9]*$/.test(String(v)) || 'Só números e ponto']"
                                                @input="val => onQtyInput(item, val)"
                                                @keypress.native="onKeypressDecimal"
                                                @paste.native.prevent="e => onPasteDecimal(item, e)"
                                                v-model="item.qty"
                                            />
                                        </td>
                                        <td>
                                            <v-btn :class="item.local == null || item.local == '' ? 'primary elevation-0' : 'primary elevation-10'" fab x-small @click="$emit('nota', item, 'subempreitada')">
                                                <v-icon v-if="item.local == null || item.local == ''">mdi-note-edit</v-icon>
                                                <v-badge
                                                    v-else
                                                    color="orange"
                                                    dot
                                                    overlap
                                                >
                                                    <v-icon>mdi-note-plus</v-icon>
                                                </v-badge>
                                            </v-btn>
                                        </td>
                                        <td>
                                            <v-btn
                                                v-if="!aggregator"
                                                dark
                                                small
                                                color="error"
                                                @click="deleteSubempreitada(item.id)"
                                                >
                                                <v-icon small>mdi-delete</v-icon>
                                            </v-btn>    
                                            <v-btn
                                                v-if="aggregator"
                                                fab
                                                dark
                                                x-small
                                                outlined
                                                color="warning"
                                                @click="edit(item)"
                                            >
                                                <v-icon dark>
                                                    mdi-pencil
                                                </v-icon>
                                            </v-btn>                         
                                        </td>
                                    
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>

                        <v-data-iterator
                            :items="fields.subempreitadas"
                            item-key="id"
                            :items-per-page="-1"
                            hide-default-footer
                            class="d-block d-lg-none"
                        >
                        <template v-slot:default="{ items }">
                            <v-row>
                                <v-col
                                    v-for="item in fields.subempreitadas"
                                    :key="item.id"
                                    cols="12"
                                >
                                    <v-card elevation="0" class="mt-2 rounded-lg" outlined>
                                        <v-list
                                            dense
                                        >
                                            <v-list-item>
                                                <v-list-item-content class="align-center">
                                                    <validation-provider v-slot="{ errors }" vid="subempreitada" name="subempreitada" rules="required">
                                                        <v-autocomplete
                                                            class="mt-4"
                                                            outlined dense
                                                            :items="subempreitadas"
                                                            :item-text="item => item.Codigo + ' - ' + item.Descricao"
                                                            item-value="Id"
                                                            label="Subempreitada"
                                                            :error-messages="errors"
                                                            v-model="item.subempreitada"
                                                        />
                                                    </validation-provider>
                                                </v-list-item-content>                                                                            
                                            </v-list-item>

                                            <v-list-item>
                                                <v-list-item-content class="align-center">
                                                    <v-text-field 
                                                        class="mt-4"
                                                        label="QTD"
                                                        outlined dense
                                                        placeholder="Insira qtd."
                                                        v-model="item.qty"
                                                        :rules="[v => v === '' || /^[0-9]*\.?[0-9]*$/.test(String(v)) || 'Só números e ponto']"
                                                        @input="val => onQtyInput(item, val)"
                                                        @keypress.native="onKeypressDecimal"
                                                        @paste.native.prevent="e => onPasteDecimal(item, e)"
                                                    />
                                                </v-list-item-content>                                                                            
                                            </v-list-item>

                                            <v-list-item>
                                                <v-list-item-content class="align-center">
                                                    <v-btn :class="item.local == null || item.local == '' ? 'primary elevation-0' : 'primary elevation-10'" fab small @click="$emit('nota', item, 'subempreitada')">
                                                        <v-icon v-if="item.local == null || item.local == ''">mdi-note-edit</v-icon>
                                                        <v-badge
                                                            v-else
                                                            color="orange"
                                                            dot
                                                            overlap
                                                        >
                                                            <v-icon>mdi-note-plus</v-icon>
                                                        </v-badge>
                                                    </v-btn>
                                                </v-list-item-content>                                                                            
                                            </v-list-item>

                                            <v-list-item>
                                                <v-list-item-content class="align-center">
                                                    <v-btn
                                                        v-if="!aggregator"
                                                        dark
                                                        small
                                                        color="error"
                                                        @click="deleteSubempreitada(item.id)"
                                                        >
                                                        <v-icon small>mdi-delete</v-icon>
                                                    </v-btn>    
                                                    <v-btn
                                                        v-if="aggregator"
                                                        fab
                                                        dark
                                                        x-small
                                                        outlined
                                                        color="warning"
                                                        @click="edit(item)"
                                                    >
                                                        <v-icon dark>
                                                            mdi-pencil
                                                        </v-icon>
                                                    </v-btn>             
                                                </v-list-item-content>                                                                            
                                            </v-list-item>
                                        </v-list>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </template>
                        </v-data-iterator>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col cols="12" align="center"  v-if="newLines">
                <v-btn fab @click="addSubempreitada" class="primary">
                    <v-icon>mdi-plus</v-icon>
                </v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import SubEmpreitada from "@/api/SubEmpreitada.js"
import Classe from "@/api/Classe.js"
import dayjs from 'dayjs'

export default{
    name:"Subcontractors",
    props:{
        newLines: {
            typeof: Boolean,
            default: true
        },
        aggregator: {
            typeof: Boolean,
            default: false
        },
        obra_selecionada:{
            typeof: Object,
            default: null
        },
        fields: Object,
        frentes_obra: Array,
        loadedClasses: Array,
        obraCodigo: { type: String, default: null },
        hideFrentes: Boolean,
    },
    watch:{
        frentes_obra: {
            handler(){ this.loadExistingRowClasses() },
            immediate: false
        },
        loadedClasses(val){
            if(this.hideFrentes && Array.isArray(val)){
                this.classes = val
                this.loadExistingRowClasses()
            }
        },
        localSubempreitadas: {
            handler(newVal) {
                this.$emit('update:fields', this.localSubempreitadas)
            },
            deep: true
        }
    },
    data(){
        return{
            subempreitadas: [],
            classes:[],
            loading: true,
            reloader: 0,
            localSubempreitadas: [], // <- nova cópia reativa
        }
    },
    mounted(){
        this.classes = this.loadedClasses
        this.fillBaseData()
        this.localSubempreitadas = this.fields.subempreitadas.map(item => {
            const frente = this.frentes_obra.find(f => f.ID === item.frente_id)
            let available_classes = Array.isArray(frente?.classes) ? frente.classes : []
            let classeNeeded = available_classes.length > 0

            if(item.classe_id != null){
                classeNeeded = true
                available_classes = this.hideFrentes ? this.classes : available_classes
            }

            return {
                ...item,
                available_classes,
                classeNeeded
            }
        })
        this.loadExistingRowClasses()
    },
    methods:{
            // mantém apenas dígitos e UM ponto
        sanitizeDecimal(v) {
            v = String(v || '');
            v = v.replace(/,/g, '');      // remove vírgulas
            v = v.replace(/[^\d.]/g, ''); // só dígitos e ponto
            const i = v.indexOf('.');
            if (i !== -1) v = v.slice(0, i + 1) + v.slice(i + 1).replace(/\./g, '');
            return v;
        },

        onQtyInput(item, val) {
            this.$set(item, 'qty', this.sanitizeDecimal(val));
        },

        onKeypressDecimal(e) {
            if (e.ctrlKey || e.metaKey) return; // permitir copiar/colar/select-all
            const k = e.key;
            if (k >= '0' && k <= '9') return;
            if (k === '.') {
            if (e.target.value.indexOf('.') !== -1) e.preventDefault(); // só um ponto
            return;
            }
            // bloqueia tudo o resto (inclui vírgula)
            e.preventDefault();
        },

        onPasteDecimal(item, e) {
            const text = (e.clipboardData || window.clipboardData).getData('text');
            const sanitized = this.sanitizeDecimal(text);
            const el = e.target;
            const start = el.selectionStart, end = el.selectionEnd;
            const newVal = el.value.slice(0, start) + sanitized + el.value.slice(end);
            this.$set(item, 'qty', this.sanitizeDecimal(newVal));
        },
        async loadExistingRowClasses(){
            if(this.hideFrentes){
                const classes = Array.isArray(this.loadedClasses) ? this.loadedClasses : []
                this.classes = classes
                this.localSubempreitadas.forEach(item => {
                    this.$set(item, 'available_classes', classes)
                    this.$set(item, 'classeNeeded', classes.length > 0 || item.classe_id != null)
                })
                return
            }
            const frentes = this.frentes_obra || []
            const usadas = frentes.filter(f => this.localSubempreitadas.some(item => item.frente_id == f.ID))
            await Promise.all(usadas.map(async frente => {
                try {
                    let classes = Array.isArray(frente.classes) ? frente.classes : []
                    if(!classes.length){
                        const resp = await Classe.getClasses({SubEmp: frente.SubEmp, obra: this.obraCodigo || null})
                        classes = Array.isArray(resp.data) ? resp.data : []
                        this.$set(frente, 'classes', classes)
                    }
                    this.localSubempreitadas.forEach(item => {
                        if(item.frente_id != frente.ID) return
                        this.$set(item, 'available_classes', classes)
                        this.$set(item, 'classeNeeded', classes.length > 0 || item.classe_id != null)
                    })
                } catch(error){console.error('Erro ao carregar classes da subempreitada:', error)}
            }))
        },
        async changeFrenteObraV2(item){
            this.$set(item, 'classe_id', null)
            this.$set(item, 'available_classes', [])
            this.$set(item, 'classeNeeded', false)
            const frente = (this.frentes_obra || []).find(f => f.ID == item.frente_id)
            if(!frente) return
            try {
                let classes = Array.isArray(frente.classes) ? frente.classes : []
                if(!classes.length){
                    const resp = await Classe.getClasses({SubEmp: frente.SubEmp, obra: this.obraCodigo || null})
                    classes = Array.isArray(resp.data) ? resp.data : []
                    this.$set(frente, 'classes', classes)
                }
                this.$set(item, 'available_classes', classes)
                this.$set(item, 'classeNeeded', classes.length > 0)
            } catch(error){console.error('Erro ao carregar classes da subempreitada:', error)}
        },
        updateField(item, campo, valor, tipo, blur = false) {
            item[campo] = valor;

            if (campo === 'frente_id') {
                this.changeFrenteObraV2(item)
            }

            // Outros campos com lógica vão aqui
        },
        showClasse(item){
            if(item.classeNeeded)
                return true

            return false
        },
        getText(ob) {
            if (ob.Descricao && ob.SubEmp && ob.Descricao.includes(ob.SubEmp)) {
                return ob.Descricao;
            }

            return `${ob.SubEmp} - ${ob.Descricao}`;
        },
        showFrente(item){
            if(this.fields.obra_id != null && this.hideFrentes == false)
                return true

            return false
        },
        lineApprovalState(item){            
            if(this.obra_selecionada == null)
                return null;
                

            let obra_nivel = this.obra_selecionada.approval_level == null ? 2 : this.obra_selecionada.approval_level
            return (item.approval == null ? 0 : item.approval) + '/' + obra_nivel
        },
        lineTotalApproved(item){  
            if(this.obra_selecionada == null)
                return false;

            if(item.approval == null)
                return false
                
            if(parseInt(this.obra_selecionada.obra.approval_level) == parseInt(item.approval))
                return true

            return false
        },
        edit(item){
            window.open(process.env.VUE_APP_API_URL + '/diarios/encarregado/editar/' + item.webAppLinkHash + "/" + item.user_id, '_blank')
        },
        deleteSubempreitada(id) {
            const index = this.localSubempreitadas.findIndex(e => e.id === id)
            if (index >= 0) {
                this.localSubempreitadas.splice(index, 1)
                this.reloader++
            }
        },
        addSubempreitada() {
            let available_classes = []
            let classeNeeded = false
            if (this.hideFrentes) {
                available_classes = this.classes
                classeNeeded = true
            }

            this.localSubempreitadas.push({
                id: dayjs().unix() + '-new',
                subempreitada: null,
                frente_id: null,
                classe_id: null,
                classeNeeded: classeNeeded,
                available_classes: available_classes,
                qty: 0,
                local: null,
                options: ""
            })
            this.reloader++
        },
        fillBaseData(){
            SubEmpreitada.all(this.fields.obra_id).then((resp)    =>  {
                this.subempreitadas = resp.data
                
                this.loading = false
            })

        }
    },
    computed:{
        computeSubempreitadas() {
            return this.localSubempreitadas
        }
    }
}
</script>